document.addEventListener("DOMContentLoaded", function () {
  const vatToggle = document.getElementById("vat-toggle-checkbox");
  const priceElement = document.getElementById("price-amount");
  const vatLabel = document.getElementById("price-vat-label");

  if (!vatToggle || !priceElement || !vatLabel) {
    console.error("Required elements for VAT toggle functionality are missing.");
    return;
  }

  // Fetch the prices directly from data attributes
  const priceExVAT = priceElement.getAttribute("data-price-ex-vat");
  const priceIncVAT = priceElement.getAttribute("data-price-inc-vat");

  if (!priceExVAT || !priceIncVAT) {
    console.error("Missing price data attributes.");
    return;
  }

  // Function to update price display
  function updatePrice() {
    if (vatToggle.checked) {
      priceElement.textContent = priceIncVAT;
      vatLabel.textContent = "Inc VAT";
      localStorage.setItem("vatToggleState", "checked");
    } else {
      priceElement.textContent = priceExVAT;
      vatLabel.textContent = "Ex VAT";
      localStorage.setItem("vatToggleState", "unchecked");
    }
  }

  // Load toggle state from localStorage
  const savedState = localStorage.getItem("vatToggleState");
  vatToggle.checked = savedState === "checked";

  // Update price on page load based on saved state
  updatePrice();

  // Add event listener to toggle price on change
  vatToggle.addEventListener("change", updatePrice);
});
